<template>
  <div class="space-list-wrap">
    <div class="img-wrap">
      <swiper :modules="[SwiperPagination,SwiperNavigation]"
              :loop="dataObj.photos.length > 1"
              :navigation="true"
              :pagination="true"
              :slides-per-view="1">
        <swiper-slide v-for="(spaceImg,photoIndex) in  dataObj.photos"
                      :key="picUrl+photoIndex">
          <div class="">
            <img :src="picUrl + spaceImg.url"
                 class="banner-swiper-img"
                 alt="空間照片"
                 @click="handleSpaceDetail(dataObj.space_id)">
          </div>
        </swiper-slide>
      </swiper>
    </div>
    <div class="space-info">
      <div>
        <div class="space_name">{{ dataObj.name }}</div>
        <div class="flex">
          <div class="address">{{ dataObj.city + dataObj.region + dataObj.address }}</div>
          <img src="@/assets/image/icon/order/distance.svg"
               alt="">
        </div>
        <div v-if="dataObj.traffic?.length > 0"
             class="flex mt-[2px]">
          <img src="@/assets/image/icon/order/directions_railway.svg"
               alt="">
          <div class="mrt">{{ parseRentMRT(dataObj.traffic) }}</div>
        </div>
        <div class="text-osn-grey-01 text-[14px] inline-flex items-center">
          <svg-icon class="mr-[4px]"
                    name="people"
                    size="16"></svg-icon>
          {{ dataObj.number_of_people_max + '人' }}
        </div>
        <div class="flex mt-[2px]">
          <!--          <div v-for="tag in handleSpaceTypeArray(dataObj.categories)"
                         class="tag">{{ tag.name }}
                    </div>-->
          <div class="tag-wrap">
            <ul>
              <li class="usage"
                  v-for="item in dataObj.categories[usageCategoryId]">{{ item.name }}
              </li>
              <!--              <li class="type"
                                v-for="item in dataObj.categories[typeCategoryId]">{{ item.name }}
                            </li>
                            <li class="tag"
                                v-for="item in dataObj.categories[tagCategoryId]">{{ item.name }}
                            </li>-->
            </ul>
          </div>
          <!--          <div class="tag">{{ dataObj.number_of_people_max + '人' }}</div>-->
        </div>
        <div v-if="dataObj.introduction"
             class="desc">
          <span>{{ dataObj.introduction }}</span>
        </div>
      </div>

      <div class="flex flex-col items-end justify-end">
        <div class="price">
          <div v-for="(price, type, index) in getTypePrice(dataObj.rent.rent_groups)">
            <div v-if="type !== 4"
                 class="ml-[16px]">
              <span>{{ `NT$${parseNumber(price)}` }}</span>
              <span class="unit">{{ ` /${parseRentUnit(type)}` }}</span>
            </div>
            <div v-else>
              {{ $t('common.period_rent') }}
            </div>
          </div>
        </div>
        <div class="less">
          <span>{{ $t('space.advance_booking_days_msg', {n: dataObj.advance_booking_days}) }}</span>
          <div class="flex"
               v-if="getMinShortestRentalDuration(dataObj.rent.rent_groups) > 0">
            <span>{{ '、' }}</span>
            <span>{{
                $t('space.rent_min_hour', {h: getMinShortestRentalDuration(dataObj.rent.rent_groups)})
              }}</span>
          </div>
        </div>
        <div class="book-btn point"
             @click="handleSpaceDetail(dataObj.space_id)">
          空間詳情
        </div>
      </div>
    </div>
  </div>
</template>

<script setup
        lang="ts">

import {ref} from "vue";
import {getMinShortestRentalDuration, getTypePrice} from "~/utils/newPriceTool";

const typeCategoryId = import.meta.env.VITE_APP_BASE_TYPE_CATEGORY_ID
const tagCategoryId = import.meta.env.VITE_APP_BASE_TAG_CATEGORY_ID
const usageCategoryId = import.meta.env.VITE_APP_BASE_USAGE_CATEGORY_ID
const router = useRouter()
const picUrl = ref(import.meta.env.VITE_APP_BASE_IMG_URL)
const props = defineProps({
  dataObj: {
    type: Object,
    default: {}
  }
})


const handleSpaceTypeArray = (categories) => {
  const typeCategoryId = import.meta.env.VITE_APP_BASE_TYPE_CATEGORY_ID

  return categories[typeCategoryId] ? categories[typeCategoryId] : []
}

const handleSpaceDetail = (spaceid) => {
  router.push({path: '/admin-space/' + spaceid})

}

</script>

<style scoped
       lang="scss">

.space-list-wrap {
  @apply w-full h-fit flex my-[30px]
  mobile:flex-col;

  .img-wrap {
    @apply pc:mr-[30px] pc:w-2/3 pc:h-[435px] pc:max-w-[650px]
    mobile:mx-4
    relative rounded-[10px];
    :deep(.swiper-button-prev ), :deep(.swiper-button-next) {
      @apply w-[30px] h-[30px] bg-white rounded-full text-black text-[10px];

      &::after {
        @apply text-[20px];
      }
    }

    :deep(.swiper-pagination-bullet-active) {
      @apply bg-osn-yellow-00;
    }

    img {
      @apply rounded-[10px] w-full pc:h-[435px] object-cover;

    }
  }

  .space-info {
    @apply flex flex-col justify-between
    pc:w-1/2
    mobile:mx-4;
    .space_name {
      @apply text-[24px] font-[500] text-osn-dark-grey-00;
    }

    .address {
      @apply text-[18px] text-osn-grey-01 mr-[4px] mt-[2px];
    }

    .mrt {
      @apply text-[16px] text-osn-dark-grey-00 ml-[4px] mt-[2px];
    }

    /* .tag {
       @apply mr-[4px] px-[10px] py-[2px] text-[14px] text-osn-white-00 rounded-full bg-osn-dark-grey-00 mt-[3px];
     }*/

    .tag-wrap {
      @apply mt-1 text-[13px];
      ul {
        @apply flex flex-wrap;
        li {
          @apply w-auto h-[23px] mr-[2px] mb-[2px] px-[6px] py-[2px] bg-osn-yellow-00 rounded-md;
        }

        li.type {
          @apply bg-osn-yellow-04 text-[11px] py-[4px];
        }

        li.tag {
          @apply bg-osn-yellow-05 text-[11px] py-[4px];
        }

      }
    }

    .desc {
      @apply max-w-full mt-[16px] p-[16px] text-[16px] text-osn-grey-01 bg-osn-grey-04 whitespace-pre-line break-all;
      span {
        @apply line-clamp-5;
      }
    }

    .price {
      @apply flex text-osn-dark-grey-00 font-medium
      pc:text-[30px]
      mobile:text-[24px];
      .unit {
        @apply text-[16px] text-osn-grey-01 font-normal;
      }
    }

    .less {
      @apply flex text-[16px] text-osn-grey-01 mb-[8px];
    }

    .book-btn {
      @apply flex items-center justify-center w-full h-[50px] text-[20px] text-osn-dark-grey-00 font-bold bg-osn-yellow-00 rounded-[50px];
    }
  }
}
</style>
